"use client";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import useIsClient from "@/hooks/useIsClient";
import { useLang } from "@/providers/langProvider";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { usePathname } from "next/navigation";

const SvgBarSearch = ({ inHeader }: { inHeader?: boolean }) => {
  const client = useIsClient();
  const pathname = usePathname();
  const lang = useLang();
  const getCompany = useGetCompanyQuery();
  const mobile_match_desktop_design =
    getCompany?.data?.result?.theme.colors.mobile_match_desktop_design;

  const selected = pathname === `/${lang}${PagesPaths.search}`;
  const fill = inHeader
    ? mobile_match_desktop_design
      ? "fill-headerIconsColor"
      : "fill-dark"
    : selected
    ? "fill-secondary"
    : "fill-gray3";
  if (!client) return;
  return (
    <svg
      className={`${fill}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width="24"
      height="20"
    >
      <path d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"></path>
    </svg>
  );
};

export default SvgBarSearch;
